
import { useStore } from "vuex"
import { useMutations } from '@/store/helper'
import { ref } from '@vue/reactivity';
import Spinner from "@/components/layout/Spinner.vue"

export default {
  name: "ApprovedDelcop",
  components: {
    Spinner
  },
  setup() {
    const loading = ref(false);
    const store = useStore();
    const dialogVisible = ref(false);
    const GotoCorreoProteccionDeDatos = ref("mailto:protecciondedatos@aportesenlinea.com");
    const Gotoaportes = ref("https://www.aportesenlinea.com");
    const styleCheckError = ref({ 'border': '3px solid red' });
    const { setTratamientoDatos } = useMutations(['setTratamientoDatos']);
    const aplicativo = localStorage.getItem('AplicativoOrigen');
    const idDocumento = ref();
    const { setStateEmpleadorHabilitado } = useMutations(['setStateEmpleadorHabilitado'])

    setStateEmpleadorHabilitado(true);

    function goToDashboard() {
      loading.value = true;
      var data = {
        Identificacion: localStorage.getItem('Identificacion'),
        Tipoidentificacion: localStorage.getItem('TipoIdentificacion'),
        IdDocumentoParaAprobar: idDocumento.value
      }
      setTratamientoDatos(data);
      store.dispatch('AprobarTTD', localStorage.getItem('Tokensin')).then(() => {
        store.dispatch('obtenerUrlDebidaDiligencia').then((response) => {
          window.open(response, "_self");
        }).catch(error => {
          console.log(error);
          loading.value = false;
        });
      }).catch(error => {
        console.log(error);
        loading.value = false;
      });

    }

    return {
      dialogVisible,
      styleCheckError,
      Error,
      Gotoaportes,
      GotoCorreoProteccionDeDatos,
      aplicativo,
      idDocumento,
      loading
    };
  }

};
